<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer033">
<p class="ORIM-Book-Title">The Lotus Crew</p>
<p class="ORIM-Author-Name">Stewart Meyer</p>
<p class="center"><img alt="logo" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Meyer_LotusCrew_4P_MD.vue?d1fbeae0